export default __webpack_public_path__ + "static/media/twitter.03a2f57e.svg";